module.exports = __webpack_public_path__ + "static/media/memory_4.9afb4410.png";